import { render, staticRenderFns } from "./dealermode-header.vue?vue&type=template&id=4a01591b"
import script from "./dealermode-header.vue?vue&type=script&lang=js"
export * from "./dealermode-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports